import {
  checkString,
  parameters,
  sendGoogleEvent,
  sendRequest,
} from '@html/_common/utils';

export default function AOClpNewsletterSignup() {
  let $form = null;
  let $input = null;
  let $cta = null;
  let ctaText = '';
  let ctaSuccessText = '';

  const onSuccess = () => {
    $cta.attr('disabled', true);
    $cta.toggleClass('ao-clp-newsletter-signup__cta--success', true);
    $input.toggleClass('ao-clp-newsletter-signup__input--success', true);

    setTimeout(() => {
      $cta.text(ctaSuccessText);
    }, 250);

    setTimeout(() => {
      $cta.text(ctaText);
      $cta.toggleClass('ao-clp-newsletter-signup__cta--success', false);
      $input.toggleClass('ao-clp-newsletter-signup__input--success', false);
      $cta.removeAttr('disabled');
    }, 2000);

    sendGoogleEvent(
      'Newsletter - Signup',
      'SignedUp',
      'CLP',
      {
        ampEventName: 'newsletter_subscribed',
      },
    );
  };

  const onSubmit = (event) => {
    event.preventDefault();
    const email = $.trim($input.val());
    if (!email || !checkString(email, 'email')) {
      alert(parameters.i18n_errors.email); // eslint-disable-line no-alert

      return false;
    }

    sendRequest('/api/subscribe/check', { email }, (data) => {
      if (data.status === 'OK') onSuccess();
    });

    return false;
  };

  const initiate = () => {
    $form = $('.js-ao-clp-newsletter-signup__form');
    $form.submit(onSubmit);

    $input = $form.find('.js-ao-clp-newsletter-signup__input');
    $cta = $form.find('.js-ao-clp-newsletter-signup__cta');
    ctaText = $form.data('text');
    ctaSuccessText = $form.data('success-text');
  };

  return { initiate };
}
